/* eslint-disable no-param-reassign */
import { createSlice, type Reducer } from '@reduxjs/toolkit';

import { CompanyEvent } from '~services/companyEvents/type';

import type { RootState } from './store';

type CompanyEventState = Partial<CompanyEvent> & { leadCapture: { enabled: boolean } };

const initialState: CompanyEventState = {
  leadCapture: {
    enabled: false,
  },
};

const slice = createSlice({
  name: 'companyEvent',
  initialState,
  reducers: {
    set(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    reset() {
      return initialState;
    },
  },
});

// Explicit reducer annotation avoids TS2742 during declaration emit after the RTK 2 upgrade.
const { reducer }: { reducer: Reducer<CompanyEventState> } = slice;

export default reducer;

export const get = (state: RootState): CompanyEventState => state[slice.name];
export const getCompany = (state: RootState) => {
  const { id, externalId, name } = state[slice.name];
  return { id, externalId, name };
};
export const isLeadCaptureEnabled = ({ companyEvent }: { companyEvent: CompanyEventState }) =>
  companyEvent.leadCapture?.enabled || false;

export const getEvent = (state: RootState) => state[slice.name].event;

export const { set, reset } = slice.actions;
